import FullScreenPopup from './FullScreenPopup';

export default FullScreenPopup;